import {Bidders} from "header-bidding-base/modules/header-bidding/domain/bidders";
import type {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import type {ILogger} from "ads-client-base/modules/logger/domain/iLogger";
import {PrebidJsBaseBiddersLoader} from "../../prebidJsBaseBiddersLoader";
import {SparteoBidder} from "../../adapters/sparteoBidder";

export class EdPrebidJsBiddersLoader extends PrebidJsBaseBiddersLoader {

    public constructor(logger: ILogger) {
        super(logger);
    }

    protected override async registerBidder(bidder: Bidders, config: HeaderBiddingConfig) {
        switch (bidder) {
            case Bidders.RICHAUDIENCE:
                const { RichAudienceBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/richAudienceBidder');
                this.bidders[bidder] = new RichAudienceBidder(config);
                break;
            case Bidders.APPNEXUS:
                const { AppNexusBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/appNexusBidder');
                this.bidders[bidder] = new AppNexusBidder(config);
                break;
            case Bidders.TEADS:
                const { TeadsBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/teadsBidder');
                this.bidders[bidder] = new TeadsBidder(config);
                break;
            case Bidders.OGURY:
                const { OguryBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/oguryBidder');
                this.bidders[bidder] = new OguryBidder(config);
                break;
            case Bidders.INDEXEXCHANGE:
                const { IndexExchangeBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/indexEchangeBidder');
                this.bidders[bidder] = new IndexExchangeBidder(config);
                break;
            case Bidders.RUBICON:
                const { RubiconBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/rubiconBidder');
                this.bidders[bidder] = new RubiconBidder(config);
                break;
            case Bidders.PUBMATIC:
                const { PubMaticBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/pubMaticBidder');
                this.bidders[bidder] = new PubMaticBidder(config);
                break;
            case Bidders.TRIPLELIFT:
                const { TripleLiftBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/tripleLiftBidder');
                this.bidders[bidder] = new TripleLiftBidder(config);
                break;
            case Bidders.OPTIDIGITAL:
                const { OptidigitalBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/optidigitalBidder');
                this.bidders[bidder] = new OptidigitalBidder(config);
                break;
            case Bidders.SPARTEO:
                const { SparteoBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/sparteoBidder');
                this.bidders[bidder] = new SparteoBidder(config);
                break;
            default:
                throw new Error(`Bidder ${bidder} not supported`);
        }
    }
}
